import { useState } from 'react';
import { Container } from 'react-bootstrap';

import { Upload } from './FormFields/Upload';
import { ControlButtons } from './ControlButtons';

export const LiabilityInsurance = ({
	currInsurance = {},
	coverageAmount,
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const [currFile, setCurrFile] = useState(currInsurance.file);
	const [currAnswer, setCurrAnswer] = useState(currInsurance.answer);
	return (
		<>
			<Container className="mt-5 component">
				<h2 className="mb-4">
					Do you have your Certificate of Liability Insurance?
				</h2>
				<p>
					A current certificate of liability insurance specific to event with
					minimum coverage of ${coverageAmount} is required for permit approval.
					<br />
					<br />
					If you don't upload a Certificate of Liability Insurance in your
					application, you must come bring one in person.
				</p>
				<Upload
					file={currFile}
					setFile={setCurrFile}
					answer={currAnswer}
					setAnswer={setCurrAnswer}
				/>
			</Container>
			<Container>
				<ControlButtons
					onSubmit={() => onSubmit({ file: currFile, answer: currAnswer })}
					onNext={() => onNext({ file: currFile, answer: currAnswer })}
					onPrev={onPrevious}
					finalStep={finalStep}
					disableNext={currAnswer === null || (currAnswer && !currFile)}
					disablePrev={disablePrev}
				/>
			</Container>
		</>
	);
};
